import http from '@/api/http'
import { createApiError, parseApiResponse } from '@/api/parseApiResponse'

export async function publicRequest(request) {
  try {
    const response = await request()
    return parseApiResponse(response)
  } catch (error) {
    if (error?.response) {
      throw createApiError(error.response)
    }
    throw error
  }
}

export async function publicList(
  path,
  { limit = 20, skip = 0, filter = {}, sort = {}, restaurantOrderSeed } = {},
) {
  const body = {
    limit,
    skip,
    filter,
    sort,
  }

  if (restaurantOrderSeed != null && String(restaurantOrderSeed).trim()) {
    body.restaurant_order_seed = String(restaurantOrderSeed).trim()
  }

  return publicRequest(() => http.post(path, body))
}

export async function publicGet(path) {
  return publicRequest(() => http.get(path))
}
